import type { Comic } from './types';

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '重生之都市仙尊',
    slug: 'rebirth-city-immortal',
    author: '墨香铜臭',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    coverSeq: 'comic-cover-01',
    coverQuery: 'Korean%20manhwa%20webtoon%20cover%20art%20handsome%20male%20protagonist%20with%20glowing%20spiritual%20energy%20surrounding%20him%20modern%20city%20background%20at%20night%20dramatic%20pose%20golden%20and%20jade%20green%20color%20scheme%20clean%20simple%20background',
    description: '一代仙尊重生回到都市少年时期，带着前世记忆与修仙功法，在繁华都市中纵横捭阖，开启了一段逆天改命的传奇旅程。凡是欺我辱我者，必百倍奉还！',
    status: '连载中',
    rating: 4.8,
    viewCount: 23456000,
    favoriteCount: 890000,
    updatedAt: '2026-07-03',
    tags: ['重生', '修仙', '都市', '逆袭', '热血'],
    chapters: [
      { id: 'ch-1-1', title: '第一章 重生归来', number: 1, updatedAt: '2026-01-15', viewCount: 1560000 },
      { id: 'ch-1-2', title: '第二章 重返校园', number: 2, updatedAt: '2026-01-22', viewCount: 1420000 },
      { id: 'ch-1-3', title: '第三章 初露锋芒', number: 3, updatedAt: '2026-01-29', viewCount: 1380000 },
      { id: 'ch-1-4', title: '第四章 灵气复苏', number: 4, updatedAt: '2026-02-05', viewCount: 1450000 },
      { id: 'ch-1-5', title: '第五章 炼气入门', number: 5, updatedAt: '2026-02-12', viewCount: 1320000 },
      { id: 'ch-1-6', title: '第六章 家族纷争', number: 6, updatedAt: '2026-02-19', viewCount: 1280000 },
      { id: 'ch-1-7', title: '第七章 初战告捷', number: 7, updatedAt: '2026-02-26', viewCount: 1410000 },
      { id: 'ch-1-8', title: '第八章 秘境探险', number: 8, updatedAt: '2026-03-05', viewCount: 1350000 },
    ],
    reviews: [
      { id: 'rv-1-1', userName: '漫画迷小王', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20man%20portrait%20friendly%20smile%20simple%20background&width=80&height=80&seq=avatar-01&orientation=squarish', rating: 5, content: '剧情紧凑，画风精美，每章都让人期待！修仙与都市结合得太好了！', date: '2026-06-28' },
      { id: 'rv-1-2', userName: '夜雨声烦', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20woman%20portrait%20gentle%20expression%20simple%20background&width=80&height=80&seq=avatar-02&orientation=squarish', rating: 5, content: '重生修仙的题材永远不会腻，这本剧情设定很新颖。', date: '2026-06-25' },
      { id: 'rv-1-3', userName: '追漫达人', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20teen%20boy%20portrait%20energetic%20expression%20simple%20background&width=80&height=80&seq=avatar-03&orientation=squarish', rating: 4, content: '画工很厉害，人物塑造也很到位，推荐！', date: '2026-06-20' },
    ],
  },
  {
    id: 'comic-2',
    title: '霸道总裁的秘密',
    slug: 'ceo-secret-love',
    author: '蓝色月光',
    category: '恋爱甜宠',
    categorySlug: 'romance',
    coverSeq: 'comic-cover-02',
    coverQuery: 'Korean%20romance%20webtoon%20cover%20art%20elegant%20CEO%20man%20in%20black%20suit%20and%20beautiful%20woman%20in%20white%20dress%20rose%20petals%20scattered%20romantic%20atmosphere%20pink%20cream%20color%20scheme%20clean%20simple%20background',
    description: '普通女孩林小雨意外成为冷面总裁的私人秘书。她本以为这只是一份普通工作，却不知总裁心中藏着不为人知的秘密……一段甜蜜又虐心的办公室恋情即将展开。',
    status: '已完结',
    rating: 4.7,
    viewCount: 18900000,
    favoriteCount: 720000,
    updatedAt: '2026-06-20',
    tags: ['恋爱', '总裁', '甜宠', '逆袭', '都市'],
    chapters: [
      { id: 'ch-2-1', title: '第一章 意外的面试', number: 1, updatedAt: '2025-08-10', viewCount: 980000 },
      { id: 'ch-2-2', title: '第二章 冷面总裁', number: 2, updatedAt: '2025-08-17', viewCount: 920000 },
      { id: 'ch-2-3', title: '第三章 深夜加班', number: 3, updatedAt: '2025-08-24', viewCount: 890000 },
      { id: 'ch-2-4', title: '第四章 心动瞬间', number: 4, updatedAt: '2025-08-31', viewCount: 950000 },
      { id: 'ch-2-5', title: '第五章 误会重重', number: 5, updatedAt: '2025-09-07', viewCount: 870000 },
      { id: 'ch-2-6', title: '第六章 雨中告白', number: 6, updatedAt: '2025-09-14', viewCount: 910000 },
      { id: 'ch-2-7', title: '终章 幸福结局', number: 7, updatedAt: '2025-09-21', viewCount: 1060000 },
    ],
    reviews: [
      { id: 'rv-2-1', userName: '甜甜的恋爱', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cute%20girl%20portrait%20sweet%20smile%20simple%20background&width=80&height=80&seq=avatar-04&orientation=squarish', rating: 5, content: '超级甜！总裁和秘书的设定永不过时！', date: '2026-06-30' },
      { id: 'rv-2-2', userName: '小白爱吃糖', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20lady%20portrait%20gentle%20smile%20simple%20background&width=80&height=80&seq=avatar-05&orientation=squarish', rating: 5, content: '完结了有点不舍，但结局很圆满！', date: '2026-06-22' },
      { id: 'rv-2-3', userName: '看漫画的猫', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20person%20with%20cat%20portrait%20cozy%20expression%20simple%20background&width=80&height=80&seq=avatar-06&orientation=squarish', rating: 4, content: '画风太美了，林小雨太可爱了！', date: '2026-06-18' },
      { id: 'rv-2-4', userName: '深夜读者', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20man%20portrait%20thoughtful%20expression%20simple%20background&width=80&height=80&seq=avatar-07&orientation=squarish', rating: 5, content: '一口气追完，每章都让人心跳加速！', date: '2026-06-15' },
    ],
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    slug: 'night-tracker',
    author: '黑羽',
    category: '惊悚悬疑',
    categorySlug: 'thriller',
    coverSeq: 'comic-cover-03',
    coverQuery: 'Korean%20thriller%20webtoon%20cover%20art%20detective%20figure%20in%20dark%20trench%20coat%20standing%20in%20rainy%20alley%20neon%20reflections%20mysterious%20silhouette%20deep%20teal%20and%20crimson%20color%20scheme%20clean%20simple%20background',
    description: '城市中连环失踪案频发，私家侦探韩辰在一次调查中意外卷入了一场惊天阴谋。每一条线索都指向同一个方向——这座城市最深处的黑暗。真相远比想象中更加恐怖……',
    status: '连载中',
    rating: 4.9,
    viewCount: 15600000,
    favoriteCount: 650000,
    updatedAt: '2026-07-02',
    tags: ['悬疑', '侦探', '犯罪', '心理', '都市'],
    chapters: [
      { id: 'ch-3-1', title: '第一章 失踪', number: 1, updatedAt: '2026-03-01', viewCount: 1200000 },
      { id: 'ch-3-2', title: '第二章 第一现场', number: 2, updatedAt: '2026-03-08', viewCount: 1150000 },
      { id: 'ch-3-3', title: '第三章 证人之死', number: 3, updatedAt: '2026-03-15', viewCount: 1180000 },
      { id: 'ch-3-4', title: '第四章 地下室', number: 4, updatedAt: '2026-03-22', viewCount: 1220000 },
      { id: 'ch-3-5', title: '第五章 神秘来电', number: 5, updatedAt: '2026-03-29', viewCount: 1080000 },
      { id: 'ch-3-6', title: '第六章 追踪', number: 6, updatedAt: '2026-04-05', viewCount: 1140000 },
    ],
    reviews: [
      { id: 'rv-3-1', userName: '推理狂魔', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20serious%20man%20portrait%20wearing%20glasses%20simple%20background&width=80&height=80&seq=avatar-08&orientation=squarish', rating: 5, content: '每一章的悬疑感都拉满，根本停不下来！', date: '2026-07-01' },
      { id: 'rv-3-2', userName: '胆小爱看', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20nervous%20girl%20portrait%20peeking%20expression%20simple%20background&width=80&height=80&seq=avatar-09&orientation=squarish', rating: 5, content: '虽然很害怕但又忍不住要看，太好看了！', date: '2026-06-28' },
      { id: 'rv-3-3', userName: '深夜不眠', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20tired%20but%20excited%20young%20man%20portrait%20simple%20background&width=80&height=80&seq=avatar-10&orientation=squarish', rating: 4, content: '剧情走向越来越刺激，每更新一章就迫不及待点开。', date: '2026-06-24' },
    ],
  },
  {
    id: 'comic-4',
    title: '武林至尊传',
    slug: 'martial-legend',
    author: '剑雨',
    category: '热血动作',
    categorySlug: 'action',
    coverSeq: 'comic-cover-04',
    coverQuery: 'Korean%20action%20webtoon%20cover%20art%20martial%20artist%20with%20long%20sword%20dramatic%20battle%20stance%20energy%20waves%20surrounding%20fiery%20orange%20and%20gold%20color%20scheme%20clean%20simple%20background',
    description: '少年林飞被神秘高手收为弟子，踏上武道修行之路。在弱肉强食的江湖中，他凭借坚韧意志和过人天赋一步步崛起，最终问鼎武林至尊之位！',
    status: '连载中',
    rating: 4.6,
    viewCount: 20100000,
    favoriteCount: 780000,
    updatedAt: '2026-07-03',
    tags: ['武侠', '热血', '修炼', '江湖', '战斗'],
    chapters: [
      { id: 'ch-4-1', title: '第一章 初入江湖', number: 1, updatedAt: '2026-02-10', viewCount: 1100000 },
      { id: 'ch-4-2', title: '第二章 拜师学艺', number: 2, updatedAt: '2026-02-17', viewCount: 1050000 },
      { id: 'ch-4-3', title: '第三章 初战', number: 3, updatedAt: '2026-02-24', viewCount: 1080000 },
      { id: 'ch-4-4', title: '第四章 秘境试炼', number: 4, updatedAt: '2026-03-03', viewCount: 1120000 },
      { id: 'ch-4-5', title: '第五章 突破', number: 5, updatedAt: '2026-03-10', viewCount: 1150000 },
    ],
    reviews: [
      { id: 'rv-4-1', userName: '江湖浪子', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cool%20man%20portrait%20confident%20smirk%20simple%20background&width=80&height=80&seq=avatar-11&orientation=squarish', rating: 5, content: '打斗场面太燃了，每一拳都有力量感！', date: '2026-07-02' },
      { id: 'rv-4-2', userName: '剑客无名', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20stoic%20man%20portrait%20sharp%20eyes%20simple%20background&width=80&height=80&seq=avatar-12&orientation=squarish', rating: 4, content: '武学体系很完善，期待后续更多招式展示。', date: '2026-06-29' },
      { id: 'rv-4-3', userName: '热血少年', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20excited%20teen%20boy%20portrait%20fist%20pump%20simple%20background&width=80&height=80&seq=avatar-13&orientation=squarish', rating: 5, content: '太好看了！每次更新都第一时间追！', date: '2026-06-26' },
    ],
  },
  {
    id: 'comic-5',
    title: '魔法学院优等生',
    slug: 'magic-academy',
    author: '星星糖',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    coverSeq: 'comic-cover-05',
    coverQuery: 'Korean%20fantasy%20webtoon%20cover%20art%20magic%20academy%20student%20casting%20spell%20with%20magic%20circle%20floating%20books%20purple%20and%20gold%20color%20scheme%20clean%20simple%20background',
    description: '平凡少年陈星被特招进入魔法学院，在这里他发现了自己与生俱来的天赋。友情、冒险、成长，一段充满魔法的校园生活就此展开！',
    status: '连载中',
    rating: 4.5,
    viewCount: 12300000,
    favoriteCount: 520000,
    updatedAt: '2026-07-01',
    tags: ['魔法', '校园', '冒险', '成长', '友情'],
    chapters: [
      { id: 'ch-5-1', title: '第一章 入学通知', number: 1, updatedAt: '2026-04-01', viewCount: 950000 },
      { id: 'ch-5-2', title: '第二章 分院仪式', number: 2, updatedAt: '2026-04-08', viewCount: 920000 },
      { id: 'ch-5-3', title: '第三章 第一堂课', number: 3, updatedAt: '2026-04-15', viewCount: 900000 },
      { id: 'ch-5-4', title: '第四章 室友的秘密', number: 4, updatedAt: '2026-04-22', viewCount: 880000 },
      { id: 'ch-5-5', title: '第五章 地下迷宫', number: 5, updatedAt: '2026-04-29', viewCount: 910000 },
    ],
    reviews: [
      { id: 'rv-5-1', userName: '魔法少女', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20magical%20girl%20portrait%20sparkly%20eyes%20simple%20background&width=80&height=80&seq=avatar-14&orientation=squarish', rating: 5, content: '魔法世界的设定太有趣了，想在这样的学校上学！', date: '2026-06-30' },
      { id: 'rv-5-2', userName: '读书人', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20bookish%20young%20man%20portrait%20simple%20background&width=80&height=80&seq=avatar-15&orientation=squarish', rating: 4, content: '画风很精美，魔法特效做得很炫。', date: '2026-06-27' },
    ],
  },
  {
    id: 'comic-6',
    title: '爆笑高中生',
    slug: 'highschool-comedy',
    author: '欢乐多',
    category: '搞笑日常',
    categorySlug: 'comedy',
    coverSeq: 'comic-cover-06',
    coverQuery: 'Korean%20comedy%20webtoon%20cover%20art%20group%20of%20high%20school%20students%20laughing%20together%20in%20classroom%20bright%20sunny%20yellow%20color%20scheme%20clean%20simple%20background',
    description: '四个性格迥异的高中生组成了学校里最"奇葩"的小团体。他们的日常充满了各种令人捧腹的搞笑事件，让你笑到腹肌酸痛！',
    status: '连载中',
    rating: 4.4,
    viewCount: 9800000,
    favoriteCount: 410000,
    updatedAt: '2026-07-02',
    tags: ['搞笑', '校园', '日常', '友情', '青春'],
    chapters: [
      { id: 'ch-6-1', title: '第一章 四人组', number: 1, updatedAt: '2026-05-01', viewCount: 850000 },
      { id: 'ch-6-2', title: '第二章 考试灾难', number: 2, updatedAt: '2026-05-08', viewCount: 820000 },
      { id: 'ch-6-3', title: '第三章 学园祭', number: 3, updatedAt: '2026-05-15', viewCount: 800000 },
      { id: 'ch-6-4', title: '第四章 修学旅行', number: 4, updatedAt: '2026-05-22', viewCount: 830000 },
      { id: 'ch-6-5', title: '第五章 告白大作战', number: 5, updatedAt: '2026-05-29', viewCount: 870000 },
    ],
    reviews: [
      { id: 'rv-6-1', userName: '笑点低', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20laughing%20girl%20portrait%20joyful%20simple%20background&width=80&height=80&seq=avatar-16&orientation=squarish', rating: 5, content: '真的笑死我了哈哈哈！每章都笑得肚子疼！', date: '2026-07-01' },
      { id: 'rv-6-2', userName: '开心果', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cheerful%20boy%20portrait%20big%20smile%20simple%20background&width=80&height=80&seq=avatar-17&orientation=squarish', rating: 5, content: '四个人的互动太有意思了，最爱男主角的吐槽！', date: '2026-06-28' },
    ],
  },
  {
    id: 'comic-7',
    title: '她来自过去',
    slug: 'she-from-past',
    author: '清风',
    category: '古风历史',
    categorySlug: 'historical',
    coverSeq: 'comic-cover-07',
    coverQuery: 'Korean%20historical%20webtoon%20cover%20art%20beautiful%20woman%20in%20traditional%20hanbok%20standing%20in%20ancient%20palace%20garden%20soft%20autumn%20leaves%20golden%20beige%20color%20scheme%20clean%20simple%20background',
    description: '现代女孩穿越到朝鲜时代，以一个卑微宫女的身份开始了在宫廷中的生活。她凭借现代智慧在古代宫廷中步步为营，还意外俘获了王世子的心……',
    status: '已完结',
    rating: 4.7,
    viewCount: 16700000,
    favoriteCount: 680000,
    updatedAt: '2026-05-15',
    tags: ['穿越', '古风', '宫廷', '恋爱', '历史'],
    chapters: [
      { id: 'ch-7-1', title: '第一章 时空裂缝', number: 1, updatedAt: '2025-06-10', viewCount: 1300000 },
      { id: 'ch-7-2', title: '第二章 初入宫廷', number: 2, updatedAt: '2025-06-17', viewCount: 1250000 },
      { id: 'ch-7-3', title: '第三章 世子殿下', number: 3, updatedAt: '2025-06-24', viewCount: 1280000 },
      { id: 'ch-7-4', title: '第四章 宫廷阴谋', number: 4, updatedAt: '2025-07-01', viewCount: 1320000 },
      { id: 'ch-7-5', title: '第五章 生死考验', number: 5, updatedAt: '2025-07-08', viewCount: 1190000 },
      { id: 'ch-7-6', title: '终章 永恒之约', number: 6, updatedAt: '2025-07-15', viewCount: 1450000 },
    ],
    reviews: [
      { id: 'rv-7-1', userName: '历史迷', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20elegant%20woman%20portrait%20traditional%20look%20simple%20background&width=80&height=80&seq=avatar-18&orientation=squarish', rating: 5, content: '对朝鲜时代细节还原得很好，故事也很感人！', date: '2026-06-25' },
      { id: 'rv-7-2', userName: '穿越爱好者', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dreamy%20girl%20portrait%20star%20eyes%20simple%20background&width=80&height=80&seq=avatar-19&orientation=squarish', rating: 5, content: '穿越+古风+恋爱的完美组合，超爱！', date: '2026-06-20' },
      { id: 'rv-7-3', userName: '清风明月', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20calm%20person%20portrait%20serene%20expression%20simple%20background&width=80&height=80&seq=avatar-20&orientation=squarish', rating: 4, content: '完结撒花！结局虽然有遗憾但很美。', date: '2026-06-18' },
    ],
  },
  {
    id: 'comic-8',
    title: '都市驱魔师',
    slug: 'urban-exorcist',
    author: '夜行者',
    category: '恐怖灵异',
    categorySlug: 'horror',
    coverSeq: 'comic-cover-08',
    coverQuery: 'Korean%20horror%20webtoon%20cover%20art%20exorcist%20holding%20talisman%20against%20dark%20spirit%20shadow%20in%20modern%20apartment%20eerie%20green%20glow%20dark%20atmosphere%20clean%20simple%20background',
    description: '大学生周明意外获得了看见鬼魂的能力。在一位神秘驱魔师的引导下，他开始学习驱魔之术，在都市的阴影中与各种超自然力量对抗。',
    status: '连载中',
    rating: 4.3,
    viewCount: 8900000,
    favoriteCount: 380000,
    updatedAt: '2026-07-01',
    tags: ['灵异', '驱魔', '都市', '超能力', '恐怖'],
    chapters: [
      { id: 'ch-8-1', title: '第一章 阴阳眼', number: 1, updatedAt: '2026-04-15', viewCount: 780000 },
      { id: 'ch-8-2', title: '第二章 第一个任务', number: 2, updatedAt: '2026-04-22', viewCount: 750000 },
      { id: 'ch-8-3', title: '第三章 红衣女鬼', number: 3, updatedAt: '2026-04-29', viewCount: 820000 },
      { id: 'ch-8-4', title: '第四章 驱魔世家', number: 4, updatedAt: '2026-05-06', viewCount: 760000 },
      { id: 'ch-8-5', title: '第五章 百鬼夜行', number: 5, updatedAt: '2026-05-13', viewCount: 800000 },
    ],
    reviews: [
      { id: 'rv-8-1', userName: '灵异控', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mysterious%20person%20portrait%20dark%20aesthetic%20simple%20background&width=80&height=80&seq=avatar-21&orientation=squarish', rating: 4, content: '画风很适合恐怖题材，氛围营造得特别好！', date: '2026-06-29' },
      { id: 'rv-8-2', userName: '不怕鬼', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20brave%20girl%20portrait%20confident%20simple%20background&width=80&height=80&seq=avatar-22&orientation=squarish', rating: 5, content: '设定很新颖，驱魔场面很有冲击力。', date: '2026-06-26' },
    ],
  },
  {
    id: 'comic-9',
    title: '咖啡店的小确幸',
    slug: 'cafe-happiness',
    author: '暖心',
    category: '治愈日常',
    categorySlug: 'slice-of-life',
    coverSeq: 'comic-cover-09',
    coverQuery: 'Korean%20healing%20webtoon%20cover%20art%20cozy%20cafe%20barista%20smiling%20behind%20counter%20steaming%20coffee%20warm%20sunlight%20through%20window%20cream%20beige%20color%20scheme%20clean%20simple%20background',
    description: '在繁华都市的一隅，有一间名为"小确幸"的咖啡店。每个来到这里的顾客都有自己的故事，而温柔的店主用一杯杯咖啡治愈着每个人的心灵。',
    status: '连载中',
    rating: 4.6,
    viewCount: 7600000,
    favoriteCount: 340000,
    updatedAt: '2026-07-02',
    tags: ['治愈', '日常', '咖啡', '温情', '生活'],
    chapters: [
      { id: 'ch-9-1', title: '第一章 一杯美式', number: 1, updatedAt: '2026-05-15', viewCount: 720000 },
      { id: 'ch-9-2', title: '第二章 失恋的客人', number: 2, updatedAt: '2026-05-22', viewCount: 690000 },
      { id: 'ch-9-3', title: '第三章 梦想的重量', number: 3, updatedAt: '2026-05-29', viewCount: 710000 },
      { id: 'ch-9-4', title: '第四章 雨天的来客', number: 4, updatedAt: '2026-06-05', viewCount: 680000 },
      { id: 'ch-9-5', title: '第五章 老板的秘密', number: 5, updatedAt: '2026-06-12', viewCount: 730000 },
    ],
    reviews: [
      { id: 'rv-9-1', userName: '咖啡爱好者', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20relaxed%20person%20portrait%20holding%20coffee%20simple%20background&width=80&height=80&seq=avatar-23&orientation=squarish', rating: 5, content: '每一章都像一杯温暖的咖啡，治愈又舒服。', date: '2026-07-01' },
      { id: 'rv-9-2', userName: '小确幸', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20warm%20smile%20girl%20portrait%20cozy%20vibe%20simple%20background&width=80&height=80&seq=avatar-24&orientation=squarish', rating: 5, content: '看这本漫画让我对生活充满希望，太治愈了！', date: '2026-06-27' },
    ],
  },
  {
    id: 'comic-10',
    title: '职场女王',
    slug: 'office-queen',
    author: '米兰达',
    category: '都市情感',
    categorySlug: 'drama',
    coverSeq: 'comic-cover-10',
    coverQuery: 'Korean%20drama%20webtoon%20cover%20art%20confident%20businesswoman%20in%20office%20attire%20looking%20out%20skyscraper%20window%20city%20skyline%20sunset%20warm%20muted%20teal%20color%20scheme%20clean%20simple%20background',
    description: '沈月从基层员工一路打拼到公司副总裁，她用十年时间证明了女性在职场中的力量。然而成功的背后，是无数个不为人知的辛酸与抉择……',
    status: '连载中',
    rating: 4.5,
    viewCount: 11200000,
    favoriteCount: 490000,
    updatedAt: '2026-06-30',
    tags: ['职场', '女性', '成长', '都市', '励志'],
    chapters: [
      { id: 'ch-10-1', title: '第一章 新人报道', number: 1, updatedAt: '2026-05-01', viewCount: 820000 },
      { id: 'ch-10-2', title: '第二章 第一次提案', number: 2, updatedAt: '2026-05-08', viewCount: 790000 },
      { id: 'ch-10-3', title: '第三章 职场PUA', number: 3, updatedAt: '2026-05-15', viewCount: 860000 },
      { id: 'ch-10-4', title: '第四章 转机', number: 4, updatedAt: '2026-05-22', viewCount: 810000 },
      { id: 'ch-10-5', title: '第五章 升职', number: 5, updatedAt: '2026-05-29', viewCount: 840000 },
    ],
    reviews: [
      { id: 'rv-10-1', userName: '职场新人', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20professional%20woman%20portrait%20determined%20simple%20background&width=80&height=80&seq=avatar-25&orientation=squarish', rating: 5, content: '职场描写的太真实了，学到了很多！', date: '2026-06-29' },
      { id: 'rv-10-2', userName: '奋斗者', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20ambitious%20young%20man%20portrait%20simple%20background&width=80&height=80&seq=avatar-26&orientation=squarish', rating: 4, content: '很励志，看沈月打拼让我自己也有了动力。', date: '2026-06-25' },
      { id: 'rv-10-3', userName: '加班中', avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20tired%20office%20worker%20portrait%20simple%20background&width=80&height=80&seq=avatar-27&orientation=squarish', rating: 5, content: '深夜加班的时候看一章，太有共鸣了哈哈。', date: '2026-06-22' },
    ],
  },
];

export const featuredComics = comics.slice(0, 6);

export const latestUpdates = [...comics].sort((a, b) =>
  new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
);

export const topRated = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 6);

export const getComicsByCategory = (slug: string): Comic[] => {
  return comics.filter((c) => c.categorySlug === slug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getComicBySlug = (slug: string): Comic | undefined => {
  return comics.find((c) => c.slug === slug);
};